<router-outlet />
<app-connection-banner />
<app-snackbar />
